export const confirm = {
    confirm: "Confirm",
    cancel: "Cancel",
    cancel_order: "Changed your mind ? You have %number_of_seconds seconds to cancel the order before it is send over the preparation.",
}